export default "__VITE_ASSET__C1Dc9bHo__"